import { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Divider, Message, Modal, useToaster } from "rsuite";
import { appCRUD } from "../../../../../actions/app";

export const SignatureAdd = (props) => {
  const { open, setOpen, studentId } = props;
  const toaster = useToaster();
  const [loading, setLoading] = useState(false);
  const sigCanvas = useRef(null);
  const [signatureData, setSignatureData] = useState(null);
  const [error, setError] = useState(null);

  const handleClear = () => {
    sigCanvas.current.clear();
    setSignatureData(null);
    setError(null);
  };

  const handleSave = () => {
    if (sigCanvas.current.isEmpty()) {
      setError("Please provide a signature first.");
      return;
    }

    const dataURL = sigCanvas.current.getCanvas().toDataURL("image/png");
    setSignatureData(dataURL);

    const dataSignature = {
      signature: dataURL,
    };

    setLoading(true);
    setTimeout(() => {
      appCRUD
        .patchStudentData(studentId, dataSignature)
        .then(() => {
          toaster.push(
            <Message type="success" showIcon header={"Success"} closable>
              <p className="h6">
                <p className="fw-bold fs-14">Signature Added Successfully</p>
              </p>
            </Message>,
            { placement: "topEnd", duration: 7000 }
          );
          setOpen(false);
          sigCanvas.current.clear();
          setSignatureData(null);
          setError(null);
          window.location.reload();
        })
        .catch(() => {})
        .finally(() => {
          setLoading(false);
        });
    }, 1000);
  };

  return (
    <>
      <Modal open={open} onClose={() => setOpen(false)} size="sm" backdrop="static">
        <Modal.Header>
          <Modal.Title>New Signature</Modal.Title>
        </Modal.Header>
        <Divider />
        <Modal.Body>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <SignatureCanvas
                  penColor="black"
                  ref={sigCanvas}
                  canvasProps={{
                    width: 500,
                    height: 300,
                    style: {
                      border: "2px solid #d26e29",
                      borderRadius: "8px",
                      width: "100%",
                      boxSizing: "border-box",
                    },
                  }}
                />
                <p className="text-danger h6">{error}</p>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-sm-12 d-flex justify-content-start"></div>
              <div className="col-md-6 col-sm-12 d-flex justify-content-end">
                <button
                  onClick={handleClear}
                  type="button"
                  className="btn btn-soft-danger btn-label waves-effect waves-light rounded-pill me-3"
                >
                  <i class="ri-forbid-line label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                  Clear
                </button>
                <button
                  type="button"
                  className="btn btn-soft-success btn-label waves-effect waves-light rounded-pill"
                  disabled={loading}
                  onClick={handleSave}
                >
                  {!loading && (
                    <span className="indicator-label">
                      <i class="ri-check-double-line label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                      Save
                    </span>
                  )}
                  {loading && (
                    <span
                      className="indicator-progress"
                      style={{ display: "block" }}
                    >
                      Please wait...
                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};
